// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__-Yg5h","infoBtn":"quickbooks_infoBtn__728nt","formBox":"quickbooks_formBox__3bkhl","formFooter":"quickbooks_formFooter__1U9Xs"};